import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { RETRIEVE_TENANT_SPECIFIC_PRODUCT_COLOR_SIZE_DETAILS_API } from '../../api/api_data';
import * as app_consts from "../../utils/app_consts";
import { fail_retrieve_tenant_specific_product_color_size_details, loading_retrieve_tenant_specific_product_color_size_details, reset_retrieve_tenant_specific_product_color_size_details, success_retrieve_tenant_specific_product_color_size_details } from '../../reducers/auth_tenant/retrieve_tenant_specific_product_color_size_details_Slice';
import { RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { addThreeDots, formatToSentenceCase, messageToast } from '../../utils/Utils';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import CardTabs from '../../pages/components/cards/CardTabs';
import { Block, BlockHead, BlockTitle, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../Component';
import DataCard from '../partials/default/DataCard';
import moment from 'moment';
import ViewHistoryDetailsModal from './ViewHistoryDetailsModal';

const ViewSpecificProductDetailsModal = ({ isOpen, closeModal, data, tenant_info, user_info }) => {

  const [page_data, setPageData] = useState(data);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retrieved_data, setRetrievedData] = useState([]);
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("Overview");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [view_history_modal, setViewHistoryModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Card Tabs
  const tabs = [
    {
      tabName: "Overview"
    },
    {
      tabName: "Inventory History"
    },
  ];


  useEffect(() => {
    if (isOpen)
    {
      // Dispatch
      dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_specific_product_color_size_details, success_retrieve_tenant_specific_product_color_size_details, fail_retrieve_tenant_specific_product_color_size_details, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SPECIFIC_PRODUCT_COLOR_SIZE_DETAILS_API}`, { warehouse_site_id: data?.selectedDetails?.warehouse_site_id, product_id: data?.selectedDetails?.product_id, color: data?.selectedDetails?.color, size: data?.selectedDetails?.size }));
    }
    setPageData(data);
    setOpen(isOpen);
  }, [data, isOpen]);

  // Listener
  const retrieve_tenant_specific_product_color_size_details_listener = useSelector((state) => state.retrieve_tenant_specific_product_color_size_details.retrieve_tenant_specific_product_color_size_details);

  useEffect(() => {
    if (retrieve_tenant_specific_product_color_size_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_specific_product_color_size_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_specific_product_color_size_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_specific_product_color_size_details_listener.message);
          messageToast(retrieve_tenant_specific_product_color_size_details_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_specific_product_color_size_details_listener.status === app_consts.SUCCESS)
        {
          setRetrievedData(retrieve_tenant_specific_product_color_size_details_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_specific_product_color_size_details());
      }
    }
  }, [retrieve_tenant_specific_product_color_size_details_listener]);

  const processInventoryData = (inventory) => {
    if (!inventory) return [];

    let balance = 0; // Initial balance

    const updatedInventory = [...inventory].reverse().map((item) => {
      balance += item.adjustment_type === "add"
        ? parseFloat(item.units)
        : -parseFloat(item.units);

      return {
        ...item,
        balance: balance.toFixed(0),
      };
    });

    return updatedInventory.reverse(); // Reverse again to restore original order
  };
  const processedInventory = processInventoryData(retrieved_data?.product_inventory);


  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = processedInventory?.slice(indexOfFirstItem, indexOfLastItem);

  const open_view_history_modal = (timestamp) => {
    const history_field = retrieved_data?.product_inventory?.find((his) => his?.inserted_at === timestamp);
    const restructed_data = { message: history_field?.inventory_audit?.message, timestamp: history_field.inserted_at };
    setSelectedHistory(restructed_data);
    setViewHistoryModal(true);
  };

  const close_view_history_modal = () => {
    setSelectedHistory([]);
    setViewHistoryModal(false);
  };

  return (
    <>
      <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={closeModal}>Specific Product Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Product Details...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Block>
                        <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                      </Block>
                      <div className='mt-4'>

                      </div>
                      {
                        activeCardTab === "Overview" && (
                          <>
                            <div className="card-inner bg-white">
                              <Block>
                                <BlockHead>
                                  <BlockTitle tag="h5">Overview</BlockTitle>
                                </BlockHead>
                                <div className="profile-ud-list">
                                  <div className="profile-ud-item">
                                    <div className="profile-ud wider">
                                      <span className="profile-ud-label">Warehouse Name</span>
                                      <span className="profile-ud-value">{retrieved_data?.product?.warehouse_name ? formatToSentenceCase(retrieved_data?.product?.warehouse_name) : "--"}</span>
                                    </div>
                                  </div>
                                  <div className="profile-ud-item">
                                    <div className="profile-ud wider">
                                      <span className="profile-ud-label">Product Name</span>
                                      <span className="profile-ud-value">{retrieved_data?.product?.name ? formatToSentenceCase(retrieved_data?.product?.name) : "--"}</span>
                                    </div>
                                  </div>
                                  <div className="profile-ud-item">
                                    <div className="profile-ud wider">
                                      <span className="profile-ud-label">Brand</span>
                                      <span className="profile-ud-value">{retrieved_data?.product?.category ? formatToSentenceCase(retrieved_data?.product?.category) : "--"}</span>
                                    </div>
                                  </div>
                                  <div className="profile-ud-item">
                                    <div className="profile-ud wider">
                                      <span className="profile-ud-label">Product Type</span>
                                      <span className="profile-ud-value">{retrieved_data?.product?.product_type ? formatToSentenceCase(retrieved_data?.product?.product_type) : "--"}</span>
                                    </div>
                                  </div>
                                  <div className="profile-ud-item">
                                    <div className="profile-ud wider">
                                      <span className="profile-ud-label">Color</span>
                                      <span className="profile-ud-value">{retrieved_data?.product?.color ? formatToSentenceCase(retrieved_data?.product?.color) : "--"}</span>
                                    </div>
                                  </div>
                                  <div className="profile-ud-item">
                                    <div className="profile-ud wider">
                                      <span className="profile-ud-label">Size</span>
                                      <span className="profile-ud-value">{retrieved_data?.product?.size ? formatToSentenceCase(retrieved_data?.product?.size) : "--"}</span>
                                    </div>
                                  </div>
                                </div>
                                <Row className="g-gs">
                                  <Col xxl="4" sm="6">
                                    <Card>
                                      <div className="nk-ecwg nk-ecwg6">
                                        <div className="card-inner">
                                          <div className="card-title-group">
                                            <div className="card-title">
                                              <h6 className="title">Total Stock In</h6>
                                            </div>
                                          </div>
                                          <div className="data">
                                            <div className="data-group">
                                              <div className="amount">{retrieved_data?.summary_warehouse_inventory?.add_units || "0"}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Card>
                                  </Col>
                                  <Col xxl="4" sm="6">
                                    <Card>
                                      <div className="nk-ecwg nk-ecwg6">
                                        <div className="card-inner">
                                          <div className="card-title-group">
                                            <div className="card-title">
                                              <h6 className="title">Total Stock Out</h6>
                                            </div>
                                          </div>
                                          <div className="data">
                                            <div className="data-group">
                                              <div className="amount">{retrieved_data?.summary_warehouse_inventory?.subtract_units || "0"}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Card>
                                  </Col>
                                  <Col xxl="4" sm="6">
                                    <Card>
                                      <div className="nk-ecwg nk-ecwg6">
                                        <div className="card-inner">
                                          <div className="card-title-group">
                                            <div className="card-title">
                                              <h6 className="title">Current Balance</h6>
                                            </div>
                                          </div>
                                          <div className="data">
                                            <div className="data-group">
                                              <div className="amount">{retrieved_data?.summary_warehouse_inventory?.balance || "0"}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Card>
                                  </Col>
                                </Row>
                              </Block>
                            </div>
                          </>
                        )
                      }
                      {
                        activeCardTab === "Inventory History" && (
                          <>
                            <div className="card-title my-2">
                              <h4 className="title">Inventory History</h4>
                            </div>
                            <Card>
                              <div className="card-inner-group">
                                <div className="card-inner p-0">
                                  <DataTableBody>
                                    <DataTableHead>
                                      <DataTableRow size="sm">
                                        <span>Message</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span>Units</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span>Balance</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span> Date</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span>Action</span>
                                      </DataTableRow>
                                    </DataTableHead>
                                    {currentItems?.length > 0
                                      ? currentItems.map((item, index) => {

                                        return (
                                          <DataTableItem key={index}>
                                            <DataTableRow size="sm">
                                              <span className="tb-product">
                                                <span className="">
                                                  {item?.inventory_audit?.message ? addThreeDots(item?.inventory_audit?.message, 60) : "--"}
                                                </span>
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.units || "0"}</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-sub">{item?.balance}</span> {/* Now displaying balance */}
                                              {item?.adjustment_type === app_consts.ADD_LOWER ? (
                                                <Icon name="caret-up-fill" className="text-success fs-22px" />
                                              ) : (
                                                <Icon name="caret-down-fill" className="text-danger fs-22px" />
                                              )}
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="tb-odr-date">
                                                {item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}
                                              </span>
                                            </DataTableRow>
                                            <DataTableRow className="nk-tb-col-tools">
                                              <div className="tb-odr-btns d-none d-sm-inline">
                                                <Button onClick={(e) => { e.preventDefault(); open_view_history_modal(item?.inserted_at); }} color="primary" size="sm" className="btn btn-dim">
                                                  View
                                                </Button>
                                              </div>
                                              <Button onClick={(e) => { e.preventDefault(); open_view_history_modal(item?.inserted_at); }} className="btn-pd-auto d-sm-none">
                                                <Icon name="chevron-right"></Icon>
                                              </Button>
                                            </DataTableRow>
                                          </DataTableItem>
                                        );
                                      })
                                      : null}
                                  </DataTableBody>
                                  <div className="card-inner">
                                    {retrieved_data?.product_inventory?.length > 0 ? (
                                      <PaginationComponent
                                        itemPerPage={itemPerPage}
                                        totalItems={retrieved_data?.product_inventory?.length}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                      />
                                    ) : (
                                      <div className="text-center">
                                        <span className="text-silent">No Products Inventory History found</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Card>
                            <ViewHistoryDetailsModal isOpen={view_history_modal} closeModal={close_view_history_modal} data={selectedHistory} title="Product History Details" />
                          </>
                        )
                      }
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>

    </>
  );
};

export default ViewSpecificProductDetailsModal;